<template>
  <div
    v-if="
      GET_ACCOUNT_DATA.id == 1 ||
        has_perm('create_apartment_contract') ||
        has_perm('update_apartment_contract')
    "
  >
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(pagetitle) }}</h3>
      </div>
      <form class="form-horizontal">
        <div class="box-body">
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                $t("contract.contract_no")
              }}</label>
              <div class="col-sm-9 col-md-9 col-lg-9">
                <input
                  v-model="contract.contract_no"
                  type="text"
                  class="form-control"
                  :placeholder="$t('contract.contract_no')"
                />
              </div>
            </div>
            <!-- hđ -->
            <div class="form-group col-lg-6">
              <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                $t("contract.bds")
              }}</label>
              <div class="col-sm-9 col-md-9 col-lg-9">
                <select v-model="contract.bds" class="form-control">
                  <option disabled hidden value="null">{{
                    $t("contract.placeho_bds")
                  }}</option>
                  <option
                    v-for="(option, idx) in realestates"
                    :key="idx"
                    :disabled="option.text == ''"
                    v-bind:value="option.value"
                  >
                    {{ option.text == "" ? $t("contract.bds") : option.text }}
                  </option>
                </select>
              </div>
            </div>
            <!-- sign date -->
            <div class="form-group col-lg-6">
              <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                $t("contract.sign_date")
              }}</label>
              <div class="col-sm-9 col-md-9 col-lg-9">
                <date-picker
                  v-model="contract.sign_date"
                  :config="options"
                ></date-picker>
              </div>
            </div>
            <!-- status -->
            <div class="form-group col-lg-6">
              <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                $t("contract.status")
              }}</label>
              <div class="col-sm-9 col-md-9 col-lg-9">
                <select v-model="contract.statusselect" class="form-control">
                  <option
                    v-for="(option, idx) in statuslist"
                    :key="idx"
                    v-bind:value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <!-- deposit -->
            <div class="form-group col-lg-6">
              <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                $t("contract.deposit")
              }}</label>
              <div class="col-sm-9 col-md-9 col-lg-9">
                <input
                  v-model="contract.deposit"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value); "
                  class="form-control"
                  :placeholder="$t('contract.deposit')"
                />
              </div>
            </div>
            <!-- money total -->
            <div class="form-group col-lg-6">
              <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                $t("contract.total_money")
              }}</label>
              <div class="col-sm-9 col-md-9 col-lg-9">
                <input
                  v-model="contract.total_money"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value); "
                  class="form-control"
                  :placeholder="$t('contract.total_money')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer" v-show="params_id == 0">
          <button
            type="button"
            class="btn btn-labeled btn-danger pull-left"
            @click="onCancel"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            type="button"
            class="btn btn-labeled btn-success pull-right"
            v-if="this.params_id == 0"
            @click="oContractSubmit"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-floppy-saved"></i>
            </span>
            {{ $t("common.add") }}
          </button>
          <button
            type="button"
            v-else
            class="btn btn-labeled btn-success pull-right"
            @click="oContractSubmit"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-floppy-saved"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </form>
    </div>
    <!-- # import file -->
    <div class="box box-primary" v-show="params_id != 0">
      <div class="box-header with-border">
        <h4 class="modal-title">{{ $t("contract.import_title") }}</h4>
        <button
          @click="handleUpload"
          type="button"
          style="float: right"
          class="btn btn-default"
        >
          <i class="fa fa-upload" aria-hidden="true"></i> Upload Files
        </button>
      </div>
      <form class="form-horizontal">
        <div class="box-body">
          <div class="row mb-1 margin-down-15">
            <div class="col-md-12">
              <div
                v-for="file in file_contract_list"
                :key="file.id"
                class="file-listing"
              >
                <div
                  style="border: solid;display: flex;margin-top:1rem;flex-direction: column;padding: 1rem;"
                >
                  <span class="name-file">
                    <a :href="file.url" target="_blank">
                      <strong>{{ file.name }}</strong>
                    </a>
                    <span
                      style="float:right; cursor: pointer;"
                      class="remove-file"
                      v-on:click.prevent="removeUrl(file.id)"
                    >
                      Remove</span
                    >
                  </span>

                  <div>
                    <span class="name-file">{{ file.date_upload }}</span> -

                    <span class="size-file">{{ readFileSize(file.size) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- pay process -->
    <div class="box box-primary" v-show="params_id != 0">
      <div class="box-header with-border">
        <h4 class="modal-title">{{ $t("contract.pay_process.title") }}</h4>

        <button
          type="button"
          class="btn btn-labeled btn-primary pull-right"
          @click="add_new_payment"
          style="margin-right: 5px;"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-plus"></i>
          </span>
          {{ $t("common.add") }}
        </button>
      </div>
      <form class="form-horizontal">
        <div class="box-body">
          <!-- /// table body -->
          <b-table
            :per-page="perPage"
            :current-page="currentPage"
            :items="payment_datalist"
            :fields="payment_column"
            class="mt-3"
            outlined
          >
            <template #head()="scope">
              <div>{{ $t(scope.label) }}</div>
            </template>
            <template slot="actions" slot-scope="row">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-danger dropdown-toggle"
                  data-toggle="dropdown"
                  aria-expanded="true"
                >
                  <i class="fa fa-fw fa-ellipsis-h"></i>
                </button>
                <ul class="dropdown-menu" style="min-width: 50px; height: 80px">
                  <li>
                    <button
                      class="btn btn-primary btn-sm"
                      style="margin-left: 6px;"
                      @click.prevent="Edit_payment_progress(row)"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                  </li>
                  <li>
                    <button
                      class="btn btn-danger btn-sm"
                      style="margin-left: 6px;"
                      @click.prevent="Delete_payment_progress(row)"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="mt-0"
          ></b-pagination>
          <!-- END TABLE -->
        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger pull-left"
            @click="onCancel"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>

          <button
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onContractSubmitUpdate"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-floppy-saved"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </form>
    </div>

    <!-- modal add new payment process -->
    <div class="modal fade" :ref="`modal-add-new-process-payment`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t("contract.pay_process.title") }}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group col-lg-6">
              <!-- period -->
              <div class="row" style="margin-top:1rem;">
                <label class="col-sm-4 col-md-4 col-lg-4">{{
                  $t("contract.pay_process.period")
                }}</label>
                <div class="col-sm-8 col-md-8 col-lg-8">
                  <input
                    v-model="pay_process.period"
                    type="number"
                    min="0"
                    oninput="this.value = Math.abs(this.value); "
                    class="form-control"
                  />
                  <span v-if="periodStatus == false" class="help is-danger">
                    <font color="red">{{ $t(error_msg.PeriodSmg) }}</font>
                  </span>
                </div>
              </div>
              <!-- payment date -->
              <div class="row" style="margin-top:1rem;">
                <label class="col-sm-4 col-md-4 col-lg-4">{{
                  $t("contract.pay_process.pay_date")
                }}</label>
                <div class="col-sm-8 col-md-8 col-lg-8">
                  <date-picker
                    v-model="pay_process.pay_date"
                    :config="options"
                  ></date-picker>
                </div>
              </div>
              <!-- rate -->
              <div class="row" style="margin-top:1rem;">
                <label class="col-sm-4 col-md-4 col-lg-4"
                  >{{ $t("contract.pay_process.rate") }} (%)</label
                >
                <div class="col-sm-8 col-md-8 col-lg-8">
                  <input
                    v-model="pay_process.rate"
                    type="number"
                    min="0"
                    max="100"
                    maxlength="3"
                    oninput="this.value = Math.abs(this.value); "
                    class="form-control"
                  />
                  <span v-if="rateStatus == false" class="help is-danger">
                    <font color="red">{{ $t(error_msg.RateSmg) }}</font>
                  </span>
                </div>
              </div>
              <!-- corresponding -->
              <div class="row" style="margin-top:1rem;">
                <label class="col-sm-4 col-md-4 col-lg-4">{{
                  $t("contract.pay_process.coressponding")
                }}</label>
                <div class="col-sm-8 col-md-8 col-lg-8">
                  <input
                    v-model="pay_process.coressponding"
                    type="text"
                    class="form-control"
                    :placeholder="$t('contract.pay_process.coressponding')"
                  />
                </div>
              </div>
              <!-- note -->
              <div class="row" style="margin-top:1rem;">
                <label class="col-sm-4 col-md-4 col-lg-4">{{
                  $t("contract.pay_process.note")
                }}</label>
                <div class="col-sm-8 col-md-8 col-lg-8">
                  <input
                    v-model="pay_process.note"
                    type="text"
                    class="form-control"
                    :placeholder="$t('contract.pay_process.note')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-warning pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="save_payment_progress"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- modal delete -->
    <div class="modal fade" :ref="`modal-delete`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("contract.delete_payment.title") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-12 col-sm-12">
                <span>{{ $t("contract.delete_payment.comment_head") }}</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-warning pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button type="button" @click="onDeletePP()" class="btn btn-primary">
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!-- modal- import -->
    <div class="modal fade" :ref="`modal-import`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t("contract.import_title") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-12 col-sm-12">
                <div
                  v-for="(file, key) in contract_files"
                  :key="file.name"
                  class="file-listing"
                >
                  <div
                    style="border: solid;display: flex;margin-top:1rem;flex-direction: column;padding: 1rem;"
                  >
                    <span class="name-file"
                      ><strong>{{ file.name }}</strong>
                      <span
                        style="float:right; cursor: pointer;"
                        class="remove-file"
                        v-on:click="removeFile(key)"
                      >
                        Remove</span
                      >
                    </span>

                    <div>
                      <span class="name-file">{{ date_uploaded }}</span> -

                      <span class="size-file">{{
                        readFileSize(file.size)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-warning pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              @click="Upload_file()"
              class="btn btn-primary"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!-- import file -->
    <div style="display:none">
      <input
        type="file"
        id="files"
        name="ImportFile"
        ref="files"
        multiple
        v-on:change="handleFilesUpload()"
        @click="$refs.files.value = null"
      />
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import utils, { uploadFileToMediaAgent } from "@/lib/utils";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import moment from "moment";
import constants from "@/lib/constantsData";

export default {
  name: "ApartmentContractAdd",
  data() {
    return {
      options: {
        format: "DD-MM-YYYY",
        useCurrent: false
      },
      realestates: [],
      statuslist: constants.contractStatusText,
      contract: {
        contract_no: "",
        bds: null,
        statusselect: null,
        sign_date: utils.getToDay(),
        deposit: 0,
        total_money: 0
      },
      error_msg: {
        RateSmg: "",
        PeriodSmg: ""
      },
      rateStatus: true,
      periodStatus: true,
      isLoading: false,
      pagetitle: "contract.editaddnew[0]",
      params_id: null,
      currentPage: 1,
      totalRows: 1,
      perPage: 20,
      contract_files: [],
      fileNames: [],
      date_uploaded: moment(Date.now()).format("DD-MM-YYYY"),
      pay_process: {
        period: 0,
        pay_date: moment(Date.now()).format("DD-MM-YYYY"),
        rate: 0,
        coressponding: 0,
        note: null
      },
      progress_detail_id: 0,
      file_contract_list: [],
      payment_delete_id: null,
      payment_datalist: [],
      payment_column: [
        {
          key: "period",
          label: "contract.pay_process.period",
          class: "text-center",
          sortable: true
        },
        {
          key: "payment_date",
          label: "contract.pay_process.pay_date",
          class: "text-center"
        },
        {
          key: "rate",
          label: "contract.pay_process.rate",
          class: "text-center"
        },
        {
          key: "corresponding",
          label: "contract.pay_process.coressponding",
          class: "text-center"
        },
        {
          key: "note",
          label: "contract.pay_process.note",
          class: "text-center"
        },
        { key: "actions", label: "common.action" }
      ]
    };
  },
  watch: {
    GET_CONTRACT_DETAIL_DATA: function() {
      let contract_detail = this.GET_CONTRACT_DETAIL_DATA;
      this.contract.contract_no = contract_detail.contract_no;
      this.contract.bds = contract_detail.realestate;
      this.contract.statusselect = contract_detail.status;
      this.contract.sign_date = utils.formatSqlDate(contract_detail.date_signed, null, "DD-MM-YYYY");
      this.contract.deposit = contract_detail.deposit;
      this.contract.total_money = contract_detail.total;
    },
    GET_APARTMENT_REALESTATE_DATA: function() {
      this.realestates = [];
      this.GET_APARTMENT_REALESTATE_DATA.forEach(bds => {
        let data = {
          value: bds.id,
          text: bds.realestate_code
        };
        this.realestates.push(data);
      });
    },
    PAYMENT_PROGRESS_DATA: function() {
      this.payment_datalist = [];
      this.PAYMENT_PROGRESS_DATA.forEach(payment => {
        let corresponding =
          (parseInt(payment.percentage) * parseInt(this.contract.total_money)) /
          100;
        let data = {
          id: payment.id,
          period: payment.period,
          payment_date: utils.formatSqlDate(payment.date_payment, null, "DD-MM-YYYY"),
          rate: payment.percentage,
          corresponding: corresponding,
          note: payment.other_details
        };
        this.payment_datalist.push(data);
      });
      this.totalRows = this.payment_datalist.length;
    },
    GET_PAYMENT_DETAIL_DATA: function() {
      let detail = this.GET_PAYMENT_DETAIL_DATA;
      let cores =
        (parseInt(detail.percentage) * parseInt(this.contract.total_money)) /
        100;
      this.pay_process.period = detail.period;
      this.pay_process.pay_date = utils.formatSqlDate(detail.date_payment, null, "DD-MM-YYYY");
      this.pay_process.rate = detail.percentage;
      this.pay_process.coressponding = cores;
      this.pay_process.note = detail.other_details;
      $(this.$refs["modal-add-new-process-payment"]).modal("show");
    },
    GET_UPLOAD_CONTRACT_LIST: function() {
      this.file_contract_list = [];
      this.GET_UPLOAD_CONTRACT_LIST.forEach(file => {
        let data = {
          id: file.id,
          name: file.file_name,
          date_upload: utils.formatSqlDate(file.date_created, null, "DD-MM-YYYY"),
          size: file.size,
          url: file.url
        };
        this.file_contract_list.push(data);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_APARTMENT_REALESTATE_DATA",
      "GET_SNACK_BAR",
      "GET_CONTRACT_DETAIL_DATA",
      "GET_ACCOUNT_DATA",
      "PAYMENT_PROGRESS_DATA",
      "GET_PAYMENT_DETAIL_DATA",
      "GET_UPLOAD_CONTRACT_LIST"
    ])
  },
  methods: {
    ...mapActions([
      "GET_APARTMENT_REALESTATE_LIST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST",
      "ADD_CONTRACT",
      "DELETE_FILE_URL",
      "UPDATE_CONTRACT",
      "SAVE_CONTRACT_FILE_INFO",
      "GET_PAYMENT_PROGRESS_DETAIL",
      "GET_UPLOAD_CONTRACT_DATA",
      "GET_CONTRACT_DETAIL",
      "ADD_PAYMENT_PROGRESS",
      "DELETE_PAYMENT_PROGRESS",
      "PAYMENT_PROGRESS_LIST",
      "SUCCESS_TOAST"
    ]),
    handleUpload: function() {
      this.$refs["files"].click();
    },
    onCancel: function() {
      this.$router.push({
        name: "ApartmentContractList"
      });
    },
    validateData: function() {
      let validatedResult = "OK";
      let validation_keys = [
        "contract_no",
        "bds",
        "sign_date",
        "deposit",
        "total_money"
      ];
      for (let key in this.contract) {
        if (validation_keys.indexOf(key) < 0) {
          continue;
        }
        if (this.contract[key] === null || this.contract[key] === "") {
          validatedResult = `Thiếu ${this.$t("contract." + key)}`;
          break;
        } else {
          //
        }
      }
      return validatedResult;
    },
    readFileSize(size) {
      if (size < 1024) return size + " B";
      let i = Math.floor(Math.log(size) / Math.log(1024));
      let num = size / Math.pow(1024, i);
      let round = Math.round(num);
      num = round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round;
      return `${num} ${"KMGTPEZY"[i - 1]}B`;
    },
    handleFilesUpload: function() {
      let uploadedFiles = this.$refs.files.files;

      let fileNameExist = "";
      let file_ext = ["exe", "mp4", "mp3"];

      for (var i = 0; i < uploadedFiles.length; i++) {
        let fileName = uploadedFiles[i].name;
        let extension = fileName.substring(fileName.lastIndexOf(".") + 1);
        if (file_ext.includes(extension)) {
          this.ON_SHOW_TOAST({
            message: fileName + " " + this.$t("contract.err_ext"),
            styleType: "danger"
          });
          return;
        }
        if (!this.fileNames.includes(fileName)) {
          this.contract_files.push(uploadedFiles[i]);
          this.fileNames.push(fileName);
        } else {
          fileNameExist += fileName + " ";
        }
      }
      if (fileNameExist != "") {
        this.ON_SHOW_TOAST({
          message: this.$t("contract.file_exist", {
            "0": fileNameExist
          }),
          styleType: "danger"
        });
      } else {
        $(this.$refs["modal-import"]).modal("show");
      }
    },
    removeFile(key) {
      this.contract_files.splice(key, 1);
      this.fileNames.splice(key, 1);
    },
    Upload_file: async function() {
      for (var i = 0; i < this.contract_files.length; i++) {
        let file = this.contract_files[i];
        let file_url = await uploadFileToMediaAgent(file, 'contract_files')
        if (file_url != null) {
          let data = {
            contract_id: parseInt(this.params_id),
            url: file_url
          }
          this.SAVE_CONTRACT_FILE_INFO(data).catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
        }
      }
      const contract = {
        params: {
          id: parseInt(this.params_id),
        }
      };
      this.isLoading = false;
      this.contract_files = [];
      this.GET_UPLOAD_CONTRACT_DATA(contract);
      $(this.$refs["modal-import"]).modal("hide");
    },
    removeUrl: function(id) {
      const contract = {
        params: {
          id: parseInt(this.params_id)
        }
      };
      this.isLoading = true;

      this.DELETE_FILE_URL(id)
        .then(
          function() {
            this.isLoading = false;
            this.GET_UPLOAD_CONTRACT_DATA(contract);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onContractSubmitUpdate: function() {
      let result = this.validateData();

      if (result == "OK") {
        let data = {
          id: parseInt(this.params_id),
          contract_number: this.contract.contract_no,
          bds: this.contract.bds,
          sign_date: utils.formatSqlDate(this.contract.sign_date, "DD-MM-YYYY", "YYYY-MM-DD"),
          status: this.contract.statusselect,
          deposit: parseInt(this.contract.deposit),
          total_money: parseInt(this.contract.total_money)
        };
        this.isLoading = true;
        this.UPDATE_CONTRACT(data)
          .then(
            function() {
              this.isLoading = false;
              this.$router.push({ name: "ApartmentContractList" });
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.isLoading = false;
              let error_data = error.response.data;
              this.ON_SHOW_TOAST({
                message: error_data.msg,
                styleType: "danger"
              });
            }.bind(this)
          );
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    oContractSubmit: function() {
      let result = this.validateData();
      if (result == "OK") {
        let data = {
          id: this.params_id,
          contract_number: this.contract.contract_no,
          bds: this.contract.bds,
          sign_date: utils.formatSqlDate(this.contract.sign_date, "DD-MM-YYYY", "YYYY-MM-DD"),
          status: this.contract.statusselect,
          deposit: parseInt(this.contract.deposit),
          total_money: parseInt(this.contract.total_money)
        };
        this.isLoading = true;
        this.ADD_CONTRACT(data)
          .then(
            function() {
              this.isLoading = false;
              this.$router.push({ name: "ApartmentContractList" });
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.isLoading = false;
              let error_data = error.response.data;
              this.ON_SHOW_TOAST({
                message: error_data.msg,
                styleType: "danger"
              });
            }.bind(this)
          );
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    Reset_payment_default: function() {
      this.pay_process.period = 0;
      this.pay_process.pay_date = moment(Date.now()).format("DD-MM-YYYY");
      this.pay_process.rate = 0;
      this.pay_process.coressponding = 0;
      this.pay_process.note = null;
    },
    Delete_payment_progress: function(row) {
      this.payment_delete_id = row.item.id;
      $(this.$refs["modal-delete"]).modal("show");
    },
    onDeletePP: function() {
      let data = {
        id: this.payment_delete_id
      };
      this.isLoading = true;
      this.DELETE_PAYMENT_PROGRESS(data)
        .then(
          function() {
            this.isLoading = false;
            const contract = {
              params: {
                id: parseInt(this.params_id)
              }
            };
            this.progress_detail_id = 0;
            this.PAYMENT_PROGRESS_LIST(contract);
            $(this.$refs["modal-delete"]).modal("hide");
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            $(this.$refs["modal-delete"]).modal("hide");
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    Edit_payment_progress: function(row) {
      this.progress_detail_id = row.item.id;
      this.isLoading = true;
      this.GET_PAYMENT_PROGRESS_DETAIL(this.progress_detail_id)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    add_new_payment: function() {
      this.progress_detail_id = 0;
      this.Reset_payment_default();
      $(this.$refs["modal-add-new-process-payment"]).modal("show");
    },
    validatePeriod: function() {
      this.error_msg.PeriodSmg = "";
      this.periodStatus = true;
      if (this.pay_process.period == null || this.pay_process.period == "") {
        this.error_msg.PeriodSmg = "common.error_msg[0].required";
        this.periodStatus = false;
      }
      return this.periodStatus;
    },
    validateRate: function() {
      this.error_msg.RateSmg = "";
      this.rateStatus = true;
      if (this.pay_process.rate == null || this.pay_process.rate == "") {
        this.error_msg.RateSmg = "common.error_msg[0].required";
        this.rateStatus = false;
      } else if (this.pay_process.rate > 100) {
        this.error_msg.RateSmg = "common.error_msg[4].payprocess_rate";
        this.rateStatus = false;
      }
      return this.rateStatus;
    },
    checkform: function() {
      let checkPeriod = this.validatePeriod();
      let checkRate = this.validateRate();
      if (checkPeriod && checkRate) {
        return true;
      } else {
        return false;
      }
    },
    save_payment_progress: function() {
      if (this.checkform()) {
        let data = {
          id: this.progress_detail_id,
          period: parseInt(this.pay_process.period),
          contract_id: parseInt(this.params_id),
          pay_date: utils.formatSqlDate(this.pay_process.pay_date, "DD-MM-YYYY", "YYYY-MM-DD"),
          rate: parseInt(this.pay_process.rate),
          note: this.pay_process.note
        };
        this.isLoading = true;
        this.ADD_PAYMENT_PROGRESS(data)
          .then(
            function() {
              const contract = {
                params: {
                  id: parseInt(this.params_id)
                }
              };
              this.progress_detail_id = 0;
              this.PAYMENT_PROGRESS_LIST(contract);
              $(this.$refs["modal-add-new-process-payment"]).modal("hide");
              this.isLoading = false;
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function() {
              $(this.$refs["modal-add-new-process-payment"]).modal("hide");
              this.isLoading = false;
              this.ERROR_TOAST();
            }.bind(this)
          );
      }
    }
  },
  mounted() {
    let id = this.$route.params.id;
    this.params_id = id;
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_APARTMENT_REALESTATE_LIST(data);
    if (id != 0) {
      this.pagetitle = "contract.editaddnew[1]";
      const contract = {
        params: {
          id: parseInt(id)
        }
      };
      this.isLoading = true;

      this.GET_CONTRACT_DETAIL({ id: this.params_id }).then(
          function() {
            this.PAYMENT_PROGRESS_LIST(contract);
            this.GET_UPLOAD_CONTRACT_DATA(contract);
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    }
  },
  components: {
    "date-picker": datePicker,
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentContractAdd.vue